import * as React from "react"
import type { SVGProps } from "react"
const SvgCheckSquareFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3 7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4zm5.45 4.25 2.15 2.15 4.95-4.95a1 1 0 0 1 .7-.27q.43 0 .7.27.27.28.28.7 0 .42-.28.7L11.3 15.5a.96.96 0 0 1-1.4 0l-2.85-2.85a1 1 0 0 1-.27-.7q0-.43.27-.7a1 1 0 0 1 .7-.28q.42 0 .7.28"
    />
  </svg>
)
export default SvgCheckSquareFilled
